import React from 'react';
import { Button, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { MUITableColumn } from 'components/shared/MUITable';
import { SmartIntakeHistoryRow } from './SmartIntakeTypes';

const OUTCOME_COLOR: Record<SmartIntakeHistoryRow['outcome'], string> = {
  confirmed: '#4caf50',
  rejected: '#ef5350',
  failed: '#ef5350',
};

interface ActionHandlers {
  onViewDetails: (row: SmartIntakeHistoryRow) => void;
}

export const createSmartIntakeHistoryTableColumns = ({
  onViewDetails,
}: ActionHandlers): MUITableColumn<SmartIntakeHistoryRow>[] => [
  {
    header: 'Upload Date',
    sortKey: 'uploadDateSortValue',
    renderKey: 'uploadDate',
    cellProps: { sx: { minWidth: 160, width: 160 } },
  },
  {
    header: 'Name',
    sortKey: 'name',
    renderKey: 'name',
    cellProps: { sx: { flex: 1 } },
  },
  {
    header: 'Outcome',
    sortKey: 'outcomeLabel',
    renderKey: 'outcomeLabel',
    cellProps: { sx: { minWidth: 140, width: 140 } },
    renderCell: row => (
      <Typography variant="body2" sx={{ color: OUTCOME_COLOR[row.outcome], fontWeight: 500 }}>
        {row.outcomeLabel}
      </Typography>
    ),
  },
  {
    header: 'Reviewed by',
    sortKey: 'reviewedByName',
    renderKey: 'reviewedByName',
    cellProps: { sx: { minWidth: 180, width: 180 } },
  },
  {
    header: 'Submission',
    renderKey: 'submissionLabel',
    cellProps: { sx: { minWidth: 180, width: 180 } },
    renderCell: row => {
      if (!row.submissionLabel) return <Typography variant="body2">—</Typography>;
      if (!row.submissionUrl) return <Typography variant="body2">{row.submissionLabel}</Typography>;
      return (
        <MuiLink component={RouterLink} to={row.submissionUrl} variant="body2">
          {row.submissionLabel}
        </MuiLink>
      );
    },
  },
  {
    header: 'Action',
    renderKey: 'id',
    cellProps: { sx: { minWidth: 140, width: 140 } },
    renderCell: row => (
      <Button size="small" variant="text" onClick={() => onViewDetails(row)}>
        View Details
      </Button>
    ),
  },
];
